import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { AdminCustomerOrder } from "@/types/customer"

type AdminCustomerOrdersState = {
  data: AdminCustomerOrder[]
  error: string | null
}

export const adminCustomerOrdersInitialState: AdminCustomerOrdersState = {
  data: [],
  error: null,
}

const adminCustomerOrdersSlice = createSlice({
  name: "adminCustomerOrders",
  initialState: adminCustomerOrdersInitialState,
  reducers: {
    setAdminCustomerOrdersAction: (
      state,
      action: PayloadAction<AdminCustomerOrder[]>,
    ) => {
      state.data = action.payload
      state.error = null
    },
    setAdminCustomerOrdersErrorAction: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.error = action.payload
    },
  },
})

export const {
  setAdminCustomerOrdersAction,
  setAdminCustomerOrdersErrorAction,
} = adminCustomerOrdersSlice.actions

export default adminCustomerOrdersSlice.reducer
